module.exports = __webpack_public_path__ + "img/mind_background_11.873eb1c5.png";